import type { V2ProjectResource } from "@generated";

export interface ChangeOrderChild {
  isChangeOrder: boolean;
  // Null for users without change-order view: the API hides the linkage from
  // them, but not the `change-order?` flag.
  parentChangeOrderId: string | null;
}

export const changeOrderChild = (
  project: Pick<V2ProjectResource, "attributes" | "relationships"> | undefined
): ChangeOrderChild => {
  const id = project?.relationships?.["parent-change-order"]?.data?.id;
  const parentChangeOrderId = id ? String(id) : null;
  return {
    isChangeOrder:
      Boolean(project?.attributes?.["change-order?"]) ||
      parentChangeOrderId !== null,
    parentChangeOrderId,
  };
};
